// probably timing problem with lit: https://github.com/lit/lit/blob/7453e365000e6a289c139cf7e175a4742296333d/packages/reactive-element/src/css-tag.ts#L10
// if lit is loaded bevor style sheet it cannot handle CSSStyleSheets from AdornisCSS
import 'construct-style-sheets-polyfill'; // THIS HAS TO BE THE FIRST IMPORT FOR FIREFOX TO WORK CORRECTLY

import { BaseQLClient } from '@adornis/baseql/client/baseqlClient.js';
import { registerServerLogger } from '@adornis/baseql/utils/logger.js';
import '@adornis/buchungsheld-db/api/index.js';
import '@adornis/buchungsheld-db/entities/index.js';
import { registerAllBHErrors } from '@adornis/buchungsheld-db/errors/register-all-errors.js';
import '@adornis/buchungsheld-db/notification/index.js'; // needed for mail-template-editor
import {
  activateAllUsedPlugins,
  registerAllBuchungsheldPlugins,
} from '@adornis/buchungsheld-db/plugins/register-all-plugins.js';
import '@adornis/buchungsheld-theme/index.js';
import '@adornis/chemistry/elements/components/x-icon.js';
import '@adornis/fonts/fonts.js';
import { TranslationEntry } from '@adornis/translation/db/translation-entry.js';
import { subscribeCurrentUser } from '@adornis/users/client/currentUser.js';
import { DateTime } from 'luxon';
import './main-element.js';

registerServerLogger();
BaseQLClient.initDefault();

void subscribeCurrentUser(() => ({
  firstName: 1,
  lastName: 1,
  email: 1,
  username: 1,
  roles: {
    _class: 1,
    name: 1,
    contexts: 1,
    permissions: 1,
  },
  suspentions: {
    _id: 1,
    institutionID: 1,
    startDate: 1,
    endDate: 1,
    reason: 1,
  },
  isLdapAccount: 1,
  emailConfirmed: 1,
  whatsappNotification: 1,
  whatsappPhone: 1,
  receivesNewsletter: 1,
}));

TranslationEntry.subscribeTranslationDictionaryAndUpdateClientTranslator().subscribe();
registerAllBHErrors();

registerAllBuchungsheldPlugins();
void activateAllUsedPlugins();

// make DateTime available to console (for debugging)
globalThis.DateTime = DateTime;
